import React, { useEffect } from 'react'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import Form from '../../../../components/Form'
import Assignees from '../../../../components/Form/Items/Assignees'
import Attachments from '../../../../components/Form/Items/Attachment'
import Deadline from '../../../../components/Form/Items/Deadline'
import Description from '../../../../components/Form/Items/Description'
import FolderSelector from '../../../../components/Form/Items/FolderSelector'
import Mandatory from '../../../../components/Form/Items/Mandatory'
import Title from '../../../../components/Form/Items/Title'

const Content = () => {
  const { form, initializeForm } = useFormProvider()

  useEffect(() => {
    initializeForm(TaskConfigurationTypes.UploadDocument)
  }, [])

  if (!form) return null

  return (
    <Form
      items={{
        title: <Title />,
        assignees: <Assignees />,
        folder: <FolderSelector />,
        description: <Description />,
        deadline: <Deadline />,
        attachments: <Attachments />,
        mandatory: <Mandatory />,
      }}
    />
  )
}

export default Content
